.showSecondPanel {
  right: -215px;
}
